var map = {
	"./Action-Figure-Folds.png": 97919,
	"./Action-Figure-Labels.png": 27279,
	"./Action-Figure.png": 31763,
	"./Background.png": 10665,
	"./Folds.png": 12990,
	"./Labels.png": 12780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48469;